import React, { useCallback, useState } from 'react';

import { Select } from '@aline/common';
import { Menu } from '@mui/material';
import { BookOpenText, Sparkles } from 'lucide-react';
import { OptionsMenuItem, PrimaryPlusIconButton } from 'src/components';
import { createNewPlaybookPrompt } from 'src/editor/toolbars/right-panel/ai/playbooks/generate-playbook-prompt';

import { useCreatePlaybookAndEdit } from './use-create-playbook-and-edit';
import { useDraftPromptInNewChat } from './use-draft-prompt-in-new-chat';

export function NewPlaybookButton(): JSX.Element {
  const [open, setOpen] = useState(false);
  const draftPromptInNewChat = useDraftPromptInNewChat();
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const { createPlaybookAndEdit, loading } = useCreatePlaybookAndEdit();
  const createWithAi = useCallback(() => {
    setOpen(false);
    draftPromptInNewChat(createNewPlaybookPrompt());
  }, [draftPromptInNewChat]);
  const createBlank = useCallback(() => {
    setOpen(false);
    void createPlaybookAndEdit();
  }, [createPlaybookAndEdit]);

  return (
    <>
      <PrimaryPlusIconButton
        ref={setAnchorEl}
        data-cy={Select.playbooks.newPlaybookButton}
        disabled={loading}
        tooltip="New Playbook"
        onClick={() => setOpen(current => !current)}
      />
      <Menu
        keepMounted
        anchorEl={anchorEl}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        open={open}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        variant="menu"
        onClose={() => setOpen(false)}
      >
        <OptionsMenuItem
          clickHandler={createBlank}
          icon={<BookOpenText size={16} />}
          text="Create blank playbook"
        />
        <OptionsMenuItem
          clickHandler={createWithAi}
          icon={<Sparkles size={16} />}
          text="Create playbook with AI"
        />
      </Menu>
    </>
  );
}
